document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
    const loginTitle = document.querySelector('.woocommerce-checkout-login__title');
    const loginForm = document.querySelector('.woocommerce-checkout-login form');

    if (loginTitle && loginForm) {
            loginTitle.addEventListener('click', function() {
                if (loginForm.style.display === 'none' || loginForm.style.display === '') {
                    loginForm.style.display = 'block';
                    loginForm.style.opacity = 0;
                    let opacity = 0;
                    const fadeIn = setInterval(function() {
                        if (opacity >= 1) {
                            clearInterval(fadeIn);
                        }
                        loginForm.style.opacity = opacity;
                        opacity += 0.1;
                    }, 50);
                } else {
                    let opacity = 1;
                    const fadeOut = setInterval(function() {
                        if (opacity <= 0) {
                            clearInterval(fadeOut);
                            loginForm.style.display = 'none';
                        }
                        loginForm.style.opacity = opacity;
                        opacity -= 0.1;
                    }, 50);
                }
            });
        }
    }, 500); // 500ms delay
});